export default class KuaiShou {
  /**
   * @description: 游戏平台
   * @enum 1 Android
   * @enum 2 iOS
   * @enum 3 微信小程序
   */
  static GAME_PLATFORM = {
    ANDROID: 1,
    IOS: 2,
    MINI_PROGRAME: 3
  }

  static MEDIA_ID = 32

  static GAME_PLATFORM_LIST = [
    { label: 'Android', value: this.GAME_PLATFORM.ANDROID },
    { label: 'iOS', value: this.GAME_PLATFORM.IOS },
    { label: '微信小程序', value: this.GAME_PLATFORM.MINI_PROGRAME }
  ]

  /**
   * @description: 广告位置枚举值
   */
  static CREATIVE_SCENE = {
    OPTIMIZE: 1, // 优选广告
    POSTIONS: 2 // 联盟广告
  }

  static CREATIVE_SCENE_LIST = [
    { label: '优选投放', value: this.CREATIVE_SCENE.OPTIMIZE },
    { label: '按场景选择投放位', value: this.CREATIVE_SCENE.POSTIONS }
  ]

  static CREATIVE_SCENE_POSITIONS = {
    SLIDE: 6, // 上下滑大屏广告
    UNION: 10, // 快手联盟优选广告
    VIDEO: 24 // 激励视频广告
  }

  static CREATIVE_SCENE_POSITIONS_LIST = [
    { label: '上下滑大屏投放', value: this.CREATIVE_SCENE_POSITIONS.SLIDE },
    { label: '快手联盟优选投放', value: this.CREATIVE_SCENE_POSITIONS.UNION },
    { label: '激励视频投放', value: this.CREATIVE_SCENE_POSITIONS.VIDEO }
  ]

  /**
   * @description: 创意制作方式枚举值
   * @unit_type https://developers.e.kuaishou.com/docs?docType=DSP&documentId=1904
   */
  static CREATIVE_UNIT_TYPE = {
    CUSTOM: 4, // 自定义
    ASSEMBLE: 7 // 程序化
  }
}
